import {
  GroupContainer,
  TagsFilterGroupName,
} from "@/components/layout/CategoryContainer";
import { getTagGroupName } from "@/features/modals/TagsModal/utils";
import { ListView, ListViewItem } from "@repo/skapa";
import { t } from "@repo/translation";
import { useSettings } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { type GroupedTags, type Tags } from "./types";

interface Props {
  id: string;
  onChange: (checked: boolean, item: Tags) => void;
  selectedKeys: string[];
  searchResult: GroupedTags;
}

export const TagsListView = ({
  id,
  onChange,
  selectedKeys,
  searchResult,
}: Props) => {
  const { market } = useSettings();

  return (
    <>
      {Object.keys(searchResult).map((type) => (
        <GroupContainer key={type}>
          <TagsFilterGroupName>
            {getTagGroupName(type, searchResult, market)}
          </TagsFilterGroupName>
          <ListView id={id}>
            {searchResult[type].map((item: Tags) => (
              <ListViewItem
                key={`${id} ${item.name}`}
                description={
                  item.translationKey ? t(item.translationKey) : item.name
                }
                control="checkbox"
                controlProps={
                  {
                    value: item.name,
                    checked: isChecked(selectedKeys, item.name),
                    onChange: (e: any) => {
                      onChange(e.target.checked, item);
                    },
                    disabled: item.isSystemGenerated,
                  } as any
                }
              />
            ))}
          </ListView>
        </GroupContainer>
      ))}
    </>
  );
};
